import { render } from "./Leads.vue?vue&type=template&id=fcd14002&scoped=true"
import script from "./Leads.vue?vue&type=script&lang=js"
export * from "./Leads.vue?vue&type=script&lang=js"

import "./Leads.vue?vue&type=style&index=0&id=fcd14002&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-fcd14002"

export default script